import * as React from 'react';

import { cn } from '@lib/utils';

const Table = (props: React.ComponentProps<'table'>) => {
  const { className, ...otherProps } = props;

  return (
    <div className="relative w-full overflow-auto">
      <table
        className={cn('w-full caption-bottom text-sm', className)}
        {...otherProps}
      />
    </div>
  );
};
Table.displayName = 'Table';

const TableHeader = (props: React.ComponentProps<'thead'>) => {
  const { className, ...otherProps } = props;

  return (
    <thead
      className={cn('[&_tr]:border-b', className)}
      {...otherProps}
    />
  );
};
TableHeader.displayName = 'TableHeader';

const TableBody = (props: React.ComponentProps<'tbody'>) => {
  const { className, ...otherProps } = props;

  return (
    <tbody
      className={cn('[&_tr:last-child]:border-0', className)}
      {...otherProps}
    />
  );
};
TableBody.displayName = 'TableBody';

const TableFooter = (props: React.ComponentProps<'tfoot'>) => {
  const { className, ...otherProps } = props;

  return (
    <tfoot
      className={cn('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className)}
      {...otherProps}
    />
  );
};
TableFooter.displayName = 'TableFooter';

const TableRow = (props: React.ComponentProps<'tr'>) => {
  const { className, ...otherProps } = props;

  return (
    <tr
      className={cn('border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted', className)}
      {...otherProps}
    />
  );
};
TableRow.displayName = 'TableRow';

const TableHead = (props: React.ComponentProps<'th'>) => {
  const { className, ...otherProps } = props;

  return (
    <th
      className={cn(
        'h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...otherProps}
    />
  );
};
TableHead.displayName = 'TableHead';

const TableCell = (props: React.ComponentProps<'td'>) => {
  const { className, ...otherProps } = props;

  return (
    <td
      className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)}
      {...otherProps}
    />
  );
};
TableCell.displayName = 'TableCell';

const TableCaption = (props: React.ComponentProps<'caption'>) => {
  const { className, ...otherProps } = props;

  return (
    <caption
      className={cn('mt-4 text-sm text-muted-foreground', className)}
      {...otherProps}
    />
  );
};
TableCaption.displayName = 'TableCaption';

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
